import { z } from 'zod';

/**
 * Tokens de API (PAT) — credencial de longa duração para agentes/integrações
 * (ex.: servidor MCP). O token completo ('lira_' + 40 hex) aparece UMA única
 * vez na criação; depois só o prefixo é exibido.
 */

export const apiTokenSchema = z.object({
  id: z.string(),
  name: z.string(),
  /** Primeiros caracteres do token ('lira_3fa8c2d1') — identificação visual. */
  tokenPrefix: z.string(),
  createdAt: z.string(),
  /** ISO ou null = nunca expira. */
  expiresAt: z.string().nullable(),
  lastUsedAt: z.string().nullable(),
});
export type ApiToken = z.infer<typeof apiTokenSchema>;

export const createApiTokenBodySchema = z.object({
  name: z.string().trim().min(1, 'Informe um nome.').max(60),
  /** Dias até expirar; omitido/null = nunca expira. */
  expiresInDays: z.number().int().min(1).max(3650).nullish(),
});
export type CreateApiTokenBody = z.infer<typeof createApiTokenBodySchema>;

export const createApiTokenResponseSchema = z.object({
  /** Token completo — exibido só nesta resposta; guarde imediatamente. */
  token: z.string(),
  apiToken: apiTokenSchema,
});
export type CreateApiTokenResponse = z.infer<typeof createApiTokenResponseSchema>;

export const apiTokensResponseSchema = z.object({
  tokens: z.array(apiTokenSchema),
});
export type ApiTokensResponse = z.infer<typeof apiTokensResponseSchema>;
